import React from 'react';
import styled from 'styled-components';

const StyledAssumeOverlay = styled.div`
  display: none;
  position: absolute;
  height: 100%;
  width: 100%;
`;

const StyledLogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: white;
  margin: 0.5em;
  height: 75%;
  transition: opacity 0.3s;
  > img {
    max-width: 100%;
    max-height: 100%;
  }
`;

export const StyledBrokerageTileContainer = styled.div`
  position: relative;
  height: 13em;
  width: 20em;
  margin: 1em 2em 1em 2em;
  background-color: rgba(235, 245, 255, 1);
  text-align: center;
  transition: background-color 0.3s;
  &:hover {
    background-color: rgba(235, 245, 255, 0.5);
    > h5,
    > h5 + div {
      opacity: 0.5;
    }
    > div:first-child {
      z-index: 100;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  > h5 {
    margin: 0;
    padding: 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    transition: opacity 0.3s;
  }
`;

export const StyledOverlay = ({
  onClick,
  children,
}: {
  onClick: () => void;
  children: any;
}) => (
  <StyledAssumeOverlay>
    <div className="btn btn-info btn-lg" onClick={onClick}>
      {children}
    </div>
  </StyledAssumeOverlay>
);

export const StyledLogo = ({ src }: { src: string }) => (
  <StyledLogoContainer>
    <img src={src} />
  </StyledLogoContainer>
);
